import React from 'react';
import Tooltip from 'ati-ui-react/components/Tip/Tooltip';
import decline from 'utils/decline';
import Icon from './Icon';
import { ContactCount, ContactWrapper } from './ContactStyle';

const stringifyCount = (count: number): string => {
  if (count <= 10) {
    return `${count}`;
  }
  const rounded = Math.floor(count / 10) * 10;
  return `${rounded}+`;
};

const Contact = ({ count = 1 }) => {
  const tooltipText = `${count} ${decline(count, [
    'контакт',
    'контакта',
    'контактов',
  ])} фирмы ${decline(count, ['подтверждён', 'подтверждено', 'подтверждено'])}`;

  return (
    <Tooltip content={tooltipText} place="top" maxWidth={136}>
      <ContactWrapper>
        <Icon />
        <ContactCount>{stringifyCount(count)}</ContactCount>
      </ContactWrapper>
    </Tooltip>
  );
};

export default Contact;
